import {createSelector} from 'reselect'
import {selectDisplay} from 'models/user/selectors'

let avatarId = 0

export const selectLoaded = (state) => state.avatars.loaded
export const selectAvatars = (state) => state.avatars.avatars

export const selectActiveAvatar = createSelector(
  selectAvatars,
  (avatars) => avatars && avatars.find((avatar) => avatar.isActive)
)

export const selectActiveAvatarRawSrc = createSelector(
  selectActiveAvatar,
  selectDisplay,
  (active, display) =>
    active
      ? `//avatars.rambler.ru/get${active.key}`
      : display
      ? display.avatar.url
      : null
)

export const selectActiveAvatarSrc = createSelector(
  selectActiveAvatarRawSrc,
  (rawSrc) =>
    /get\/(.+)\/default/.test(rawSrc) === false
      ? rawSrc
      : `${rawSrc}?v=${avatarId++}`
)
